import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import API, { formatApiErrorDetail } from "../lib/api";
import EmployerLayout, { StatusBanner } from "./EmployerLayout";
import { useAppT } from "../components/home/i18n";

const inputCls = "mt-1 w-full rounded-sm border border-[#E8E4DB] bg-white px-3 py-2.5 text-sm outline-none focus:border-[#1F4A38] focus:ring-1 focus:ring-[#1F4A38]";
const Field = ({ label, children }) => (<div><label className="text-xs font-medium text-[#5C5855]">{label}</label>{children}</div>);

export default function EmployerOrganization() {
  const { a } = useAppT();
  const [status, setStatus] = useState("none");
  const [reason, setReason] = useState(null);
  const [form, setForm] = useState({ org_name: "", reg_number: "", country: "", website: "", contact_name: "", contact_role: "", contact_phone: "" });
  const [saving, setSaving] = useState(false);

  const load = async () => {
    const { data } = await API.get("/employer/organization");
    setStatus(data.status);
    if (data.organization) { setForm({ ...form, ...data.organization }); setReason(data.organization.review_reason); }
  };
  useEffect(() => { load(); }, []);

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await API.post("/employer/organization", form);
      setStatus(data.status); setReason(data.organization?.review_reason);
      toast.success(a.empOrg.submitted);
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  const locked = status === "verified";
  return (
    <EmployerLayout>
      <h1 className="font-serif text-3xl text-[#173A2C]">{a.empOrg.title}</h1>
      <p className="mt-1 text-sm text-[#5C5855]">{a.empOrg.sub}</p>
      <div className="mt-4"><StatusBanner status={status} reason={reason} /></div>

      <form onSubmit={submit} className="mt-6 grid gap-4 rounded-md border border-[#E8E4DB] bg-white p-6 sm:grid-cols-2">
        <Field label={a.empOrg.orgName}><input data-testid="org-name" required className={inputCls} value={form.org_name} onChange={upd("org_name")} disabled={locked} /></Field>
        <Field label={a.empOrg.regNumber}><input data-testid="org-reg" className={inputCls} value={form.reg_number} onChange={upd("reg_number")} disabled={locked} /></Field>
        <Field label={a.empOrg.country}><input data-testid="org-country" required className={inputCls} value={form.country} onChange={upd("country")} disabled={locked} /></Field>
        <Field label={a.empOrg.website}><input className={inputCls} value={form.website} onChange={upd("website")} disabled={locked} /></Field>
        <Field label={a.empOrg.contactName}><input data-testid="org-contact" required className={inputCls} value={form.contact_name} onChange={upd("contact_name")} disabled={locked} /></Field>
        <Field label={a.empOrg.contactRole}><input className={inputCls} value={form.contact_role} onChange={upd("contact_role")} disabled={locked} /></Field>
        <Field label={a.empOrg.contactPhone}><input className={inputCls} value={form.contact_phone} onChange={upd("contact_phone")} disabled={locked} /></Field>
        {!locked && (
          <div className="sm:col-span-2">
            <button data-testid="org-submit" disabled={saving} className="rounded-full bg-[#1F4A38] px-5 py-2.5 text-sm font-semibold text-white disabled:opacity-50">{saving ? a.common.submitting : status === "none" ? a.empOrg.submitFor : a.empOrg.updateResubmit}</button>
          </div>
        )}
      </form>
    </EmployerLayout>
  );
}
